import { z } from 'zod'
import { oc } from '@orpc/contract'
import { boardItemSchema, boardSchema } from './boards-shared.contract'

export const boardList = oc
  .route({ method: 'GET', path: '/v2/boards' })
  .input(z.object({}).optional())
  // Columns and groups ride along so a caller can build a create form for a
  // board it hasn't opened (PD-1588's chart modal) without pulling its items.
  .output(z.object({ boards: z.array(boardSchema) }))

export const boardCreate = oc
  .route({ method: 'POST', path: '/v2/boards' })
  .input(z.object({ name: z.string().trim().min(1).max(120) }))
  .output(z.object({ board: boardSchema }))

export const boardGet = oc
  .route({ method: 'GET', path: '/v2/boards/{id}' })
  .input(z.object({ id: z.string() }))
  // readAt = the calling user's read map (task id → the newest note time they've
  // seen); drives the per-user unread indicator.
  .output(
    z.object({
      board: boardSchema,
      items: z.array(boardItemSchema),
      readAt: z.record(z.string(), z.string()),
      // PD-1863: current phone of each patient on the board, keyed by `Patient/<id>`.
      patientPhones: z.record(z.string(), z.string()),
      // True when the caller may rename/delete this board (owner or super admin).
      canManage: z.boolean(),
    }),
  )

export const boardRename = oc
  .route({ method: 'PATCH', path: '/v2/boards/{id}' })
  .input(z.object({ id: z.string(), name: z.string().trim().min(1).max(120) }))
  .output(z.object({ board: boardSchema }))

export const boardDelete = oc
  .route({ method: 'DELETE', path: '/v2/boards/{id}' })
  .input(z.object({ id: z.string() }))
  .output(z.object({ id: z.string() }))

export const boardAddColumn = oc
  .route({ method: 'POST', path: '/v2/boards/{id}/columns' })
  .input(z.object({ id: z.string(), label: z.string().trim().min(1).max(80) }))
  .output(z.object({ board: boardSchema }))

export const boardRenameColumn = oc
  .route({ method: 'PATCH', path: '/v2/boards/{id}/columns/{columnId}' })
  .input(
    z.object({ id: z.string(), columnId: z.string(), label: z.string().trim().min(1).max(80) }),
  )
  .output(z.object({ board: boardSchema }))

// Distinct path (`column-order`, not `columns/…`) so it doesn't collide with the
// `columns/{columnId}` rename/remove routes.
export const boardReorderColumns = oc
  .route({ method: 'PATCH', path: '/v2/boards/{id}/column-order' })
  .input(z.object({ id: z.string(), columnIds: z.array(z.string()).min(1) }))
  .output(z.object({ board: boardSchema }))

export const boardRemoveColumn = oc
  .route({ method: 'DELETE', path: '/v2/boards/{id}/columns/{columnId}' })
  .input(z.object({ id: z.string(), columnId: z.string() }))
  .output(z.object({ board: boardSchema }))
